import React from "react";
import { Section, Eyebrow, Reveal, KW } from "./shared";
import { PROBLEMS } from "../../lib/site";

export default function Problem() {
  return (
    <Section id="problem" bg="bg-brand-cream">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#0B31EB">Why Most Experts Struggle</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          You Don&rsquo;t Have a Content Problem.<br />
          You Have a <KW c="#E90019">Strategy</KW> Problem.
        </h2>
        <p className="text-base sm:text-lg text-brand-ink/75 mt-5">
          You have knowledge and expertise—but without a clear strategy, every video feels like starting from zero.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mt-12">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.n} delay={(i % 3) * 0.08}>
            <div className="h-full rounded-[24px] border-2 border-brand-blue bg-brand-palegreen p-6 transition-transform duration-300 hover:-translate-y-1.5"
              style={{ boxShadow: "8px 10px 0 #0B31EB" }}>
              <span className="font-display text-2xl text-brand-blue">{p.n}</span>
              <h3 className="font-bold text-lg sm:text-xl mt-3">{p.t}</h3>
              <p className="text-sm text-brand-ink/75 mt-2 leading-relaxed">{p.d}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 rounded-[32px] border-2 border-brand-black bg-brand-black text-brand-cream p-8 sm:p-12 text-center"
          style={{ boxShadow: "10px 12px 0 #E90019" }}>
          <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl">Random Videos Create Random Results.</h3>
          <p className="text-brand-cream/75 mt-4 max-w-2xl mx-auto text-base sm:text-lg">
            You do not need more content without direction. You need a clear system behind every video.
          </p>
        </div>
      </Reveal>
    </Section>
  );
}
